<template>
  <div id="main" class="mt-24">
    <div class="content page-order-checkout checkout">
      <div class="js-checkout-address-box">
        <div class="gray-box clear">
          <div class="title columns-title pre-title">
            <h2>收货信息</h2>
          </div>
          <div class="box-inner js-checkout-address-panel">
            <div class="address-common-table js-multiple-address-panel">
              <ul class="address-item-list clear js-address-item-list">
                <li
                  class="js-choose-address"
                  :class="{ 'selected-address-item': item.default }"
                  v-for="(item, index) in receiveInfo"
                  :key="index"
                  @click="chooseReceive(index)"
                >
                  <div class="address-item">
                    <div class="name-section">{{ item.name }}</div>
                    <div class="mobile-section">{{ item.phone }}</div>
                    <div class="detail-section">
                      {{ item.province }}{{ item.city }}{{ item.county }}<br />
                      {{ item.add }}
                    </div>
                  </div>
                  <div class="operation-section">
                    <span class="update-btn js-edit-address">修改</span>
                    <span class="delete-btn js-delete-address">删除</span>
                  </div>
                </li>
                <li class="add-address-item js-add-address" @click="showPop">
                  <p>使用新地址</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="gray-box">
        <div class="title">
          <h2>发票信息</h2>
        </div>
        <div class="box-inner invoice-box js-invoice-box">
          <p class="invoice-detail">发票类型：电子发票</p>
          <div class="invoice-detail">
            发票抬头：
            <div class="radio-box">
              <label>
                <input type="radio" class="hide" />
                <span
                  class="blue-radio"
                  :class="{ 'blue-radio-on': invoices.personal }"
                  @click="checkedInvoices(true)"
                  ><a></a
                ></span>
                个人
              </label>
              <label>
                <input type="radio" class="hide" />
                <span
                  class="blue-radio"
                  :class="{ 'blue-radio-on': !invoices.personal }"
                  @click="checkedInvoices(false)"
                  ><a></a
                ></span>
                单位
              </label>
            </div>
            <div class="module-form-row form-item fn-hide js-invoice-title">
              <div
                class="module-form-item-wrapper no-icon small-item"
                v-if="!invoices.personal"
              >
                <i v-if="invoices.company == ''">请填写公司发票抬头</i>
                <input
                  type="text"
                  class="js-verify"
                  v-model="invoices.company"
                />
              </div>
            </div>
          </div>
          <p class="invoice-detail">发票内容：购买商品明细</p>
          <p class="invoice-label">
            电子发票是税务局认可的有效收付款凭证，可作为售后服务凭据。电子发票打印后可以用于企业报销。
          </p>
        </div>
      </div>
      <div class="gray-box">
        <div class="title pre-title">
          <h2>购物清单</h2>
        </div>
        <div class="box-inner ui-goods-cart">
          <div class="gray-sub-title cart-table-title">
            <span class="name">商品名称</span>
            <span class="subtotal">小计</span>
            <span class="num">数量</span>
            <span class="price">单价</span>
          </div>
          <div class="cart-table">
            <div class="cart-group js-cart-group">
              <div
                class="cart-items"
                v-for="item in checkedGoods"
                :key="item.goods_id"
              >
                <div class="items-thumb">
                  <a href="javascript:;" target="_blank"
                    ><img :src="item.img"
                  /></a>
                </div>
                <div class="name hide-row">
                  <div class="name-cell"></div>
                </div>
                <div class="subtotal">
                  <div class="subtotal-cell">
                    ¥ {{ item.count * item.price }}.00
                  </div>
                </div>
                <div class="goods-num">{{ item.count }}</div>
                <div class="price">¥ {{ item.price }}.00</div>
              </div>
            </div>
          </div>
        </div>
        <div class="box-inner">
          <div class="order-discount-line">
            <p>
              商品总计： <span>¥ {{ checkedPrice }}.00</span>
            </p>
            <p>
              运费： <span>+ ¥ {{ freight }}.00</span>
            </p>
            <p class="discount-line js-discount-cash">
              <em>现金券</em>： <span> - 0 </span>
            </p>
          </div>
        </div>
        <div class="box-inner">
          <div class="last-payment clear">
            <span
              class="jianguo-blue-main-btn big-main-btn payment-blue-bt fn-right js-checkout"
              @click="submitOrderHandle"
            >
              <a>提交订单</a>
            </span>
            <span class="prices fn-right"
              >应付金额： <em>¥ {{ checkedPrice + freight }}.00</em></span
            >
          </div>
        </div>
      </div>
    </div>
    <address-pop v-if="isShow" @closePop="closePop"></address-pop>
  </div>
</template>

<script>
import "@/assets/css/checkout.css";
import AddressPop from "@/components/address-pop.vue";
export default {
  data() {
    return {
      isShow: false,
      invoices: {
        personal: true,
        company: "",
      },
    };
  },
  methods: {
    //修改默认地址
    chooseReceive(index) {
      this.$store.commit("chooseReceive", index);
    },
    //弹出地址窗口
    showPop() {
      this.isShow = true;
    },
    closePop(val) {
      this.isShow = val;
    },
    checkedInvoices(val) {
      this.invoices.personal = val;
    },
    //提交订单
    submitOrderHandle() {
      //收件人、发票、商品三类信息集合到一个对象。
      //发票处理
      if (this.invoices.personal) {
        this.invoices.company = "个人";
      }
      //获取时间
      let iDate = new Date();
      let date = iDate.getDate();
      if (date >= 1 && date <= 9) {
        date = "0" + date;
      }
      let month = iDate.getMonth() + 1;
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }

      let data = {
        receive: this.receiveInfo.filter((item) => {
          return item.default == true;
        }),
        goods: this.checkedGoods, //商品信息
        invoices: this.invoices.company, //发票信息
        orderId: iDate.getTime(), //订单号
        orderDate:
          iDate.getFullYear() +
          "-" +
          month +
          "-" +
          date +
          " " +
          iDate.getHours() +
          ":" +
          iDate.getMinutes() +
          ":" +
          iDate.getSeconds, //订单日期
        price: this.checkedPrice,
        freight: this.freight,
        isPay: false, //付款状态
      };
      //将数据传入Vuex
      this.$store.commit("submitOrder", data);
      //路由跳转
      this.$router.push({
        name: "Payment",
        query: { orderId: data.orderId },
      });
    },
  },
  computed: {
    //已选商品信息
    checkedGoods() {
      return this.$store.getters.checkoutData;
    },
    //购物车选中数量
    checkedPrice() {
      return this.$store.getters.checkedPrice;
    },
    freight() {
      var freight = 0;
      if (this.checkedPrice > 0 && this.checkedPrice < 88) {
        freight = 8;
      }
      return freight;
    },
    //地址信息
    receiveInfo() {
      return this.$store.state.receiveInfo;
    },
  },
  components: {
    AddressPop,
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/checkout.vue